/*!
 * Copyright (c) Microsoft. All rights reserved.
 * Licensed under the MIT license. See LICENSE file in the project.
 */
import styled from '@essex/styled-components'
export const Container = styled.div`
	width: auto;
	display: flex;
	flex-direction: column;
`
